//src/pages/TikpagBIQueda.jsx

import React from "react";
import TikpagBIVariacaoBase from "./TikpagBIVariacaoBase";

export default function TikpagBIQueda() {
  return <TikpagBIVariacaoBase tipo="queda" />;
}